import { render } from "./InformacoesGeraisBySilo.vue?vue&type=template&id=533d8ea8"
import script from "./InformacoesGeraisBySilo.vue?vue&type=script&lang=js"
export * from "./InformacoesGeraisBySilo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__